import { applyMiddleware, createStore } from "redux";
import thunk from "redux-thunk";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import rootReducers from "./rootReducers";
import { composeWithDevTools } from "redux-devtools-extension";
const middleware = applyMiddleware(thunk);

// [TS-P-06] Slices that must not be written to localStorage on every change:
// - StopWatchReducer: the running stopwatch value; StopWatch restores itself
//   from its own localStorage keys (startTimeRef / stopwatchTime / isStart).
// - Timesheet request/response slices that no component reads (the screen
//   uses the promise each thunk returns); persisting them only kept timesheet
//   records in localStorage and re-serialised them on every update.
const persistConfig = {
  key: "root",
  storage,
  blacklist: [
    "StopWatchReducer",
    "AddMemberTimesheetReducer",
    "GetMemberTimesheetReducer",
    "UpdateTimesheetProjectReducer",
    "AddMemberTimetrackerReducer",
    "EditMemberTimetrackerReducer",
    "CopyLastWeekTsReducer",
    "AddTsTemplateReducer",
    "GetTsTemplateReducer",
    "UpdateTsTemplateReducer",
    "ActivateTemplateReducer",
    "TimeSheetDetailsReducer",
  ],
};
const persistedReducer = persistReducer(persistConfig, rootReducers);
const store = createStore(persistedReducer, composeWithDevTools(middleware));
const persistor = persistStore(store);

export { store, persistor };
